export const MODAL_NONE = 'MODAL_NONE';
export const COLUMN_EDITOR_CONTAINER_MODAL = 'COLUMN_EDITOR_CONTAINER_MODAL';
export const CREATE_VIEW_FROM_QUEUE_MODAL = 'CREATE_VIEW_FROM_QUEUE_MODAL';
export const CREATE_VIEW_MODAL = 'CREATE_VIEW_MODAL';
export const DELETE_TASK_CONFIRMATION_MODAL = 'DELETE_TASK_CONFIRMATION_MODAL';
export const UNASSOCIATED_TASK_MODAL = 'UNASSOCIATED_TASK_MODAL';